export const firebaseConfig = {
 apiKey: "AIzaSyCEz10vxozai9H4Ufg9nyq-LBBCHV62_0E",
 authDomain: "doctor-bari.firebaseapp.com",
 projectId: "doctor-bari",
 storageBucket: "doctor-bari.appspot.com",
 messagingSenderId: "41365855876",
 appId: "1:41365855876:web:f323b2ebfa2e1ab3daecd1"
};
